// extracted by mini-css-extract-plugin
module.exports = {"companyLogo":"styles_companyLogo__s9kht"};